import http from './http'
import qs from 'qs'

export default {
    all(query = {}) {
        return http.get(`bienparabien/solicitudes?${qs.stringify(query)}`)
    }
}